<script lang="ts">
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import DepositOrWithdraw from './depositOrWithdraw/DepositOrWithdraw.svelte';
	import Swap from './swap/Swap.svelte';
	import TransferMargin from './transferMargin/TransferMargin.svelte';
	import type { Actions } from './types';

	// const actions: Actions[] = ['Deposit', 'Withdraw', 'Swap', 'Transfer Margin'];
	const actions: Actions[] = ['Deposit', 'Withdraw'];
	export let selectedAction: Actions = 'Deposit';

	function onSelectAction(action: Actions) {
		selectedAction = action;
	}
</script>

<GradientBorder
	gradient="bg-fx-gradient-6"
	paddingClass="p-px"
	borderRadius="rounded-2xl"
	outerClassList="w-fit h-fit"
	innerClassList="bg-fx-gradient-8 min-w-[456px] p-6"
>
	<div class="flex justify-around">
		{#each actions as action}
			<button
				class={`${
					selectedAction == action
						? 'bg-fx-gradient-1 text-fx-grey-900'
						: 'bg-fx-gradient-8 text-fx-grey-200 border-fx-grey-500 border'
				} px-16 py-2 text-sm rounded-lg squircle-lg font-semibold`}
				on:click={() => onSelectAction(action)}
				on:keydown={() => onSelectAction(action)}>{action}</button
			>
		{/each}
	</div>

	<div class="border-t border-t-fx-grey-600 w-full my-4" />

	{#if selectedAction === 'Deposit'}
		<DepositOrWithdraw componentType="Deposit" />
	{:else if selectedAction === 'Withdraw'}
		<DepositOrWithdraw componentType="Withdraw" />
		<!-- {:else if selectedAction === 'Swap'}
		<Swap />
	{:else if selectedAction === 'Transfer Margin'}
		<TransferMargin /> -->
	{/if}
</GradientBorder>
